import * as actions from './actions';
import {
    GET_AGREEMENTS,
    SET_AGREEMENTS_LOADING_FALSE,
    SET_BORROWER_AGREEMENTS,
    SET_LENDER_AGREEMENTS,
    SET_USER_BORROWS,
} from './constants';

import { Agreement, ROLE } from '@/shared/api/borrow';

export type AgreementState = {
    lenderAgreements: Agreement[];
    borrowerAgreements: Agreement[];
    userBorrows: Agreement[];
    selectedAgreement?: ROLE;
    agreementsLoading: boolean;
};

export const AgreementDefault = {
    address: '',
    apy: '0',
    icon: '',
    leverageTokenId: 0,
    role: ROLE.OWNER,
    title: '',
    totalDeposited: '',
    description: '',
    collaterals: [''],
    lenders: [''],
    borrowers: [''],
    leverage: {
        id: 0,
        address: '',
        name: '',
        symbol: '',
        balance: '',
        decimals: 0,
    },
    liquidationFee: '',
    liquidationThreshold: '',
    marginCallThreshold: '',
    stressTestMatrix: [{ symbol: '', percent: '', address: '', priceProvider: '', priceModel: '' }],
    totalPosition: '',
    poolBalance: '',
    withdrawable: '',
    interestAccrued: '',
    interestClaimable: '',
    totalBorrowed: '',
    poolUtilization: '0',
    noWalletInfo: false,
    errorContract: false,
};

const defaultState: AgreementState = {
    lenderAgreements: [AgreementDefault],
    borrowerAgreements: [AgreementDefault],
    userBorrows: [AgreementDefault],
    agreementsLoading: false,
};

type OrderAction = ReturnType<TInferValueTypes<typeof actions>>;

export default function agreements(state = defaultState, action: OrderAction): AgreementState {
    switch (action.type) {
        case GET_AGREEMENTS: {
            return {
                ...state,
                selectedAgreement: action.payload?.role,
                agreementsLoading: true,
            };
        }

        case SET_LENDER_AGREEMENTS: {
            return {
                ...state,
                lenderAgreements: action.payload,
                agreementsLoading: false,
            };
        }

        case SET_BORROWER_AGREEMENTS: {
            return {
                ...state,
                borrowerAgreements: action.payload,
                agreementsLoading: false,
            };
        }

        case SET_USER_BORROWS: {
            return {
                ...state,
                userBorrows: action.payload,
            };
        }

        case SET_AGREEMENTS_LOADING_FALSE: {
            return {
                ...state,
                agreementsLoading: false,
            };
        }

        default: {
            return state;
        }
    }
}
